import ReportService from '@/api/ReportService'

export const transformPosSales = (input = []) => {
  return input.map((item) => {
    return {
      'date': item.date,
      'sessionsCount': item.sessions_count,
      'cashiersCount': item.cashiers_count,
      'transactionsCount': item.transactions_count,
      'productsCount': item.products_count,
      'cost': item.cost,
      'discount': item.discount,
      'tax': item.tax,
      'collect': item.collect,
      'refund': item.refund,
      'net': item.net,
      'profit': item.profit,
    }
  })
}

export const transformPosCashiers = (input = []) => {
  return input.map((item) => {
    return {
      'date': item.date,
      'cashiers': item.cashiers.map((cashier) => {
        return {
          'cashierId': cashier.cashier_id,
          'name': cashier.name,
          'sessionsCount': cashier.sessions_count,
          'transactionsCount': cashier.transactions_count,
          'productsCount': cashier.products_count,
          'newCustomersCount': cashier.new_customers_count,
          'oldCustomersCount': cashier.old_customers_count,
          'net': cashier.net,
          'profit': cashier.profit,
        }
      }),
    }
  })
}

export const transformPosProducts = (input = []) => {
  return input.map((item) => {
    return {
      'date': item.date,
      'skus': item.skus.map((sku) => {
        return {
          'quantity': sku.quantity,
          'cost': sku.cost,
          'discount': sku.discount,
          'tax': sku.tax,
          'collect': sku.collect,
          'refund': sku.refund,
          'net': sku.net,
          'profit': sku.profit,
          'psId': sku.ps_id,
          'psCode': sku.ps_code,
          'posbioId': sku.posbio_id,
          'cashierId': sku.cashier_id,
          'shopId': sku.shop_id,
          'productId': sku.product_id,
          'skuId': sku.sku_id,
          'catId': sku.cat_id,
          'customer': sku.customer,
        }
      }),
    }
  })
}

export const transformPosProductsDetails = (input = []) => {
  return input.map((item) => {
    return {
      'cost': item.cost == null ? 0 : item.cost,
      'discount': item.discount == null ? 0 : item.discount,
      'tax': item.tax == null ? 0 : item.tax,
      'collect': item.collect == null ? 0 : item.collect,
      'refund': item.refund == null ? 0 : item.refund,
      'net': item.net == null ? 0 : item.net,
      'profit': item.profit == null ? 0 : item.profit,
      'ps_id': item.ps_id,
      'ps_code': item.ps_code,
      'posbi_id': item.posbi_id,
      'posbio_id': item.posbio_id,
      'cashier_id': item.cashier_id,
      'product_id': item.product_id,
      'sku_id': item.sku_id,
      'cat_id': item.cat_id,
      'quantity': item.quantity == null ? 0 : item.quantity,
      'created_at': item.created_at,
      'customer': item.customer,
    }
  })
}

export const transformPosCategories = (input = []) => {
  return input.map((item) => {
    return {
      'date': item.date,
      'categories': item.categories.map((category) => {
        return {
          'quantity': category.quantity,
          'cost': category.cost,
          'discount': category.discount,
          'tax': category.tax,
          'collect': category.collect,
          'refund': category.refund,
          'net': category.net,
          'profit': category.profit,
          'psId': category.ps_id,
          'psCode': category.ps_code,
          'posbioId': category.posbio_id,
          'cashierId': category.cashier_id,
          'shopId': category.shop_id,
          'productId': category.product_id,
          'skuId': category.sku_id,
          'catId': category.cat_id,
        }
      }),
    }
  })
}

export const transformInventoryStocks = (input = []) => {
  return input.map((item) => {
    return {
      'date': item.date,
      'totalBalance': item.total_balance,
      'totalBalanceMin': item.total_balance_min,
      'totalBalanceMax': item.total_balance_max,
      'totalBalanceAvg': item.total_balance_avg,
      'totalIn': item.total_in,
      'totalOut': item.total_out,
      'value': item.value,
      'totalBehavior': {
        'gr': item.total_behavior.gr,
        'gi': item.total_behavior.gi,
        'gt': item.total_behavior.gt,
        'pos': item.total_behavior.pos,
        'recipe': item.total_behavior.recipe,
        'manualInitial': item.total_behavior['manual initial'],
        'manualLoss': item.total_behavior['manual loss'],
        'manualReceived': item.total_behavior['manual received'],
        'manualRecount': item.total_behavior['manual recount'],
        'manualDamage': item.total_behavior['manual damage'],
        'manualReturn': item.total_behavior['manual return'],
        'manualTransfer': item.total_behavior['manual transfer'],
        'manualCreateLotNumber': item.total_behavior['manual create lot number'],
        'manualCreateSerialNumber': item.total_behavior['manual create serial number'],
        'manualUpdateLotNumber': item.total_behavior['manual update lot number'],
        'manualUpdateSerialNumber': item.total_behavior['manual update serial number'],
        'manualDeleteLotNumber': item.total_behavior['manual delete lot number'],
        'manualDeleteSerialNumber': item.total_behavior['manual delete serial number'],
        'manualConsumedProduction': item.total_behavior['manual consumed production'],
        'manualReceivedProduction': item.total_behavior['manual received production'],
        'manualIssue': item.total_behavior['manual issue'],
      },
      'skus': item.skus.map((sku) => {
        return {
          'totalBalance': sku.total_balance,
          'totalBalanceMin': sku.total_balance_min,
          'totalBalanceMax': sku.total_balance_max,
          'totalBalanceAvg': sku.total_balance_avg,
          'totalIn': sku.total_in,
          'totalOut': sku.total_out,
          'value': sku.value,
          'totalBehavior': {
            'gr': sku.total_behavior.gr,
            'gi': sku.total_behavior.gi,
            'gt': sku.total_behavior.gt,
            'pos': sku.total_behavior.pos,
            'recipe': sku.total_behavior.recipe,
            'manualInitial': sku.total_behavior['manual initial'],
            'manualLoss': sku.total_behavior['manual loss'],
            'manualReceived': sku.total_behavior['manual received'],
            'manualRecount': sku.total_behavior['manual recount'],
            'manualDamage': sku.total_behavior['manual damage'],
            'manualReturn': sku.total_behavior['manual return'],
            'manualTransfer': sku.total_behavior['manual transfer'],
            'manualCreateLotNumber': sku.total_behavior['manual create lot number'],
            'manualCreateSerialNumber': sku.total_behavior['manual create serial number'],
            'manualUpdateLotNumber': sku.total_behavior['manual update lot number'],
            'manualUpdateSerialNumber': sku.total_behavior['manual update serial number'],
            'manualDeleteLotNumber': sku.total_behavior['manual delete lot number'],
            'manualDeleteSerialNumber': sku.total_behavior['manual delete serial number'],
            'manualConsumedProduction': sku.total_behavior['manual consumed production'],
            'manualReceivedProduction': sku.total_behavior['manual received production'],
            'manualIssue': sku.total_behavior['manual issue'],
          },
          'info': {
            'skuId': sku.info.sku_id,
            'productId': sku.info.product_id,
            'productName': sku.info.sku_id,
            'cost': sku.info.cost,
            'createdAt': sku.info.created_at,
          },
        }
      }),
    }
  })
}

export const transformPosDiningOptions = (input = []) => {
  return input.map((item) => {
    return {
      'date': item.date,
      'diningOptions': item.payment_methods.map((item) => {
        return {
          'diningType': item.dining_type,
          'transaction': item.transaction,
          'quantity': item.quantity,
          'cost': item.cost,
          'discount': item.discount,
          'tax': item.tax,
          'collect': item.collect,
          'refund': item.refund,
          'net': item.net,
          'profit': item.profit,
        }
      }),
    }
  })
}

export const transformPosPaymentMethods = (input = []) => {
  return input.map((item) => {
    return {
      'date': item.date,
      'paymentMethods': item.payment_methods.map((item) => {
        return {
          'paymentType': item.payment_type,
          'transaction': item.transaction,
          'quantity': item.quantity,
          'cost': item.cost,
          'discount': item.discount,
          'tax': item.tax,
          'collect': item.collect,
          'refund': item.refund,
          'net': item.net,
          'profit': item.profit,
        }
      }),
    }
  })
}

export const transformExpenseData = (input = []) => {
  return input.map((item) => {
    return {
      'date': item.date,
      'items': item.items.map((item) => {
        return {
          'fieldName': item.field_name,
          'quantity': item.quantity,
          'subTotal': item.sub_total,
          'taxTotal': item.tax_total,
          'grandTotal': item.grand_total,
        }
      }),
    }
  })
}

export const transformPurchaseData = (input = []) => {
  return input.map((item) => {
    return {
      'date': item.date,
      'items': item.items.map((item) => {
        return {
          'fieldName': item.field_name,
          'skuQuantity': item.sku_quantity,
          'subTotal': item.sub_total,
          'discountTotal': item.discount_total,
          'taxTotal': item.tax_total,
          'grandTotal': item.grand_total,
        }
      }),
    }
  })
}

// initial state
const state = {
  income_statement: null,
  posSales: transformPosSales([]),
  posCashiers: transformPosCashiers([]),
  posProducts: transformPosProducts([]),
  posProductsDetails: [],
  posCategories: transformPosCategories([]),
  posDiningOptions: transformPosDiningOptions([]),
  posPaymentMethods: transformPosPaymentMethods([]),
  inventoryStocks: transformInventoryStocks([]),
  expenseData: transformExpenseData([]),
  purchaseData: transformPurchaseData([]),
}

// getters
const getters = {
  getIncomeStatement: state => state.income_statement,
}

// mutations
const mutations = {
  setIncomeStatement (state, data) {
    state.income_statement = data
  },
  clearIncomeStatement (state) {
    state.income_statement = null
  },
  setPosSales (state, data = []) {
    state.posSales = transformPosSales(data)
  },
  setPosCashiers (state, data = []) {
    state.posCashiers = transformPosCashiers(data)
  },
  setReportPosProducts (state, data = []) {
    state.posProducts = transformPosProducts(data)
  },
  setReportPosProductsDetails (state, data = []) {
    state.posProductsDetails = transformPosProductsDetails(data)
  },
  setReportPosCategories (state, data = []) {
    state.posCategories = transformPosCategories(data)
  },
  setReportPosDiningOptions (state, data = []) {
    state.posDiningOptions = transformPosDiningOptions(data)
  },
  setReportPosPaymentMethods (state, data = []) {
    state.posPaymentMethods = transformPosPaymentMethods(data)
  },
  setInventoryStocks (state, data = []) {
    state.inventoryStocks = transformInventoryStocks(data)
  },
  setExpenseData (state, data = []) {
    state.expenseData = transformExpenseData(data)
  },
  setPurchaseData (state, data = []) {
    state.purchaseData = transformPurchaseData(data)
  },
}

// actions
const actions = {

  async getIncomeStatement ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getIncomeStatement') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getIncomeStatement')

      let response = await ReportService.getIncomeStatement(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getIncomeStatement')

      result = response.data

      if (result.success) {
        commit('setIncomeStatement', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async clearIncomeStatement ({ commit }) {
    commit('clearIncomeStatement')
  },

  async getPosSales ({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPosSales') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPosSales')

      const response = await ReportService.getPosSales(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPosSales')

      result = response.data

      if (result.success) {
        commit('setPosSales', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getPosCashiers ({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPosCashiers') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPosCashiers')

      const response = await ReportService.getPosCashiers(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPosCashiers')

      result = response.data

      if (result.success) {
        commit('setPosCashiers', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getReportPosProducts ({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPosProducts') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPosProducts')

      const response = await ReportService.getPosProducts(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPosProducts')

      result = response.data

      if (result.success) {
        commit('setReportPosProducts', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getReportPosProductsDetails ({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPosProductsDetails') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPosProductsDetails')

      const response = await ReportService.getPosProductsDetails(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPosProductsDetails')

      result = response.data

      if (result.success) {
        commit('setReportPosProductsDetails', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getReportPosCategories ({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPosCategories') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPosCategories')

      const response = await ReportService.getPosCategories(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPosCategories')

      result = response.data

      if (result.success) {
        commit('setReportPosCategories', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getReportPosDiningOptions ({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getReportPosDiningOptions') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getReportPosDiningOptions')

      const response = await ReportService.getPosDiningOptions(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getReportPosDiningOptions')

      result = response.data

      if (result.success) {
        commit('setReportPosDiningOptions', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getReportPosPaymentMethods ({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getReportPosPaymentMethods') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getReportPosPaymentMethods')

      const response = await ReportService.getPosPaymentMethods(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getReportPosPaymentMethods')

      result = response.data

      if (result.success) {
        commit('setReportPosPaymentMethods', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getInventoryStocks ({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getInventoryStocks') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getInventoryStocks')

      const response = await ReportService.getInventoryStocksSkus(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getInventoryStocks')

      result = response.data

      if (result.success) {
        commit('setInventoryStocks', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getReportExpenseData ({ commit }, { path = '', params = {} }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getReportExpenseData') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getReportExpenseData')

      const response = await ReportService.getExpenseData(path, params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getReportExpenseData')

      result = response.data

      if (result.success) {
        commit('setExpenseData', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getReportPurchaseData ({ commit }, { path = '', params = {} }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getReportPurchaseData') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getReportPurchaseData')

      const response = await ReportService.getPurchaseData(path, params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getReportPurchaseData')

      result = response.data

      if (result.success) {
        commit('setPurchaseData', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Report.js